<template>
  <div style="margin: 30px auto 0;">
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-position="right"
      label-width="250px"
    >
      <el-row>
        <el-col :span="10">
          <el-form-item label="公司名称" prop="groupName">
            <el-input
              v-model="form.groupName"
              clearable
              readonly
              maxlength="256"
            />
          </el-form-item>
          <el-form-item label="注册地址" prop="registeredAddress">
            <el-input
              v-model="form.registeredAddress"
              placeholder="请输入注册地址"
              maxlength="512"
              clearable
            />
          </el-form-item>
          <el-form-item label="注册资金（万元）" prop="registeredCapital">
            <el-input
              v-model="form.registeredCapital"
              placeholder="请输入注册资金（万元）"
              maxlength="255"
              clearable
            />
          </el-form-item>
          <el-form-item
            label="统一社会信用代码注册时间"
            prop="uniformSocialCreditTime"
          >
            <el-date-picker
              v-model="form.uniformSocialCreditTime"
              type="date"
              placeholder="选择日期"
            />
          </el-form-item>
          <el-form-item label="经营范围" prop="businessScope">
            <el-input
              v-model="form.businessScope"
              placeholder="请输入经营范围"
              type="textarea"
              maxlength="2000"
              autosize
              clearable
            />
          </el-form-item>
          <el-form-item label="企业成立时间" prop="establishmentDate">
            <el-date-picker
              v-model="form.establishmentDate"
              type="date"
              placeholder="选择日期"
            />
          </el-form-item>
          <el-form-item label="营业执照注册时间" prop="registerDate">
            <el-date-picker
              v-model="form.registerDate"
              type="date"
              placeholder="选择日期"
            />
          </el-form-item>
          <el-form-item label="所属辖区" prop="countrySubdivisionCode">
            <el-cascader
              ref="countrySubdivisionCode"
              v-model="form.countrySubdivisionCode"
              :options="countyOptions"
              :props="{
                value: 'countyCode',
                label: 'countyName',
                children: 'children'
              }"
              @change="handleChange"
            />
          </el-form-item>
          <el-form-item label="法人姓名" prop="legalPersonName">
            <el-input
              v-model="form.legalPersonName"
              placeholder="请输入法人姓名"
              maxlength="50"
              clearable
            />
          </el-form-item>
          <el-form-item label="法人手机号" prop="legalPersonTelephoneNumber">
            <el-input
              v-model="form.legalPersonTelephoneNumber"
              placeholder="请输入法人手机号"
              maxlength="60"
              clearable
            />
          </el-form-item>
          <el-form-item label="联系人名称" prop="contactName">
            <el-input
              v-model="form.contactName"
              placeholder="请输入联系人名称"
              maxlength="255"
              clearable
            />
          </el-form-item>
          <el-form-item label="联系人电话" prop="contactPhone">
            <el-input
              v-model="form.contactPhone"
              placeholder="请输入联系人电话"
              maxlength="50"
              clearable
            />
          </el-form-item>
        </el-col>
        <!-- /// -->
        <el-col :span="10">
          <el-form-item
            label="联系人手机号"
            prop="contactMobileTelephoneNumber"
          >
            <el-input
              v-model="form.contactMobileTelephoneNumber"
              placeholder="请输入联系人手机号"
              maxlength="50"
              clearable
            />
          </el-form-item>
          <el-form-item label="电信业务经营许可证编号" prop="ipcnum">
            <el-input
              v-model="form.ipcnum"
              placeholder="请输入电信业务经营许可证编号"
              maxlength="50"
              clearable
            />
          </el-form-item>
          <el-form-item label="三级等保备案编号" prop="psnrnum">
            <el-input
              v-model="form.psnrnum"
              placeholder="请输入三级等保备案编号"
              maxlength="50"
              clearable
            />
          </el-form-item>
          <el-form-item label="传真号码" prop="faxNo">
            <el-input
              v-model="form.faxNo"
              placeholder="请输入传真号码"
              maxlength="13"
              clearable
            />
          </el-form-item>
          <el-form-item label="业务类型" prop="businessType">
            <el-input
              v-model="form.businessType"
              placeholder="请输入干线普货运输、城市配送、农村配送、集装箱运输、港口物流、其他等六类"
              maxlength="255"
              clearable
            />
          </el-form-item>
          <el-form-item label="经营货物类型" prop="cargoType">
            <el-input
              v-model="form.cargoType"
              placeholder="请输入电子产品，商品汽车，冷藏货物，大宗货物，快速消费品，农产品，其他"
              maxlength="255"
              clearable
            />
          </el-form-item>
          <el-form-item label="经营区域" prop="managementArea">
            <el-input
              v-model="form.managementArea"
              placeholder="请输入经营区域"
              maxlength="255"
              clearable
            />
          </el-form-item>
          <el-form-item label="分公司个数" prop="brancheCount">
            <el-input
              v-model="form.brancheCount"
              placeholder="请输入分公司个数"
              clearable
              @input="
                value =>
                  formFormatter.isInteger(value, oldValue, form, 'brancheCount')
              "
            />
          </el-form-item>
          <el-form-item label="运管机构报备个数" prop="reportCount">
            <el-input
              v-model="form.reportCount"
              placeholder="请输入已报备机构"
              clearable
              @input="
                value =>
                  formFormatter.isInteger(value, oldValue, form, 'reportCount')
              "
            />
          </el-form-item>
          <el-form-item label="实际承运人个数" prop="actualCarrierCount">
            <el-input
              v-model="form.actualCarrierCount"
              placeholder="请输入实际承运人个数"
              clearable
              @input="
                value =>
                  formFormatter.isInteger(
                    value,
                    oldValue,
                    form,
                    'actualCarrierCount'
                  )
              "
            />
          </el-form-item>
          <el-form-item label="实际车辆个数" prop="vehicleCount">
            <el-input
              v-model="form.vehicleCount"
              placeholder="请输入实际车辆个数"
              clearable
              @input="
                value =>
                  formFormatter.isInteger(value, oldValue, form, 'vehicleCount')
              "
            />
          </el-form-item>
          <el-form-item label="实际承运人个数" prop="driverCount">
            <el-input
              v-model="form.driverCount"
              placeholder="请输入实际承运人个数"
              clearable
              @input="
                value =>
                  formFormatter.isInteger(value, oldValue, form, 'driverCount')
              "
            />
          </el-form-item>
          <el-form-item label="是否上报" prop="report">
            <el-select v-model="form.report" placeholder="请选择" disabled>
              <el-option
                v-for="item in reportOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              v-if="getLimit('sysSetting_gd_submit_button')"
              type="primary"
              @click="funcSubmitJs"
            >
              确 定
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- app信息 -->
    <div class="titleh1" />
    <vxe-toolbar
      id="toolbarId_st1"
      :custom="{ storage: true }"
      export
      :refresh="{ query: appArry }"
    >
      <template v-slot:buttons>
        <!-- <el-button @click="funcFilter()">查询</el-button> -->
        <el-button v-if="getLimit('sysSetting_gd_add_button')" @click="funcAdd">
          新增
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      show-footer
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      height="300"
      :loading="loading"
      :data="appArry"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
    >
      <vxe-table-column type="checkbox" width="70" />
      <vxe-table-column field="appId" title="appId" min-width="240" />
      <vxe-table-column field="appName" title="app名称" min-width="240" />
      <vxe-table-column
        field="appSecurity"
        title="企业app安全码"
        min-width="240"
      />
      <vxe-table-column
        field="appType"
        title="app类型"
        :formatter="formatterSendFundStatus"
        min-width="240"
      />
      <vxe-table-column title="操作" min-width="150">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="编辑" placement="top">
            <vxe-button type="text" @click="funcEdit(scope.row.code)">
              <i class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除" placement="top">
            <vxe-button type="text" @click="funcDelete(scope.row.code)">
              <i class="el-icon-delete" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-modal
      v-model="modelAddFlag"
      title="新增"
      width="700"
      height="450"
      resize
    >
      <compAdd
        @fatherAddMethod="fatherAdd"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <vxe-modal
      v-model="modelEditFlag"
      title="编辑"
      width="860"
      height="600"
      resize
    >
      <compEdit
        ref="editRef"
        @fatherEditMethod="fatherEdit"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <!-- ///分割线 -->
  </div>
</template>

<script>
import request from "@/utils/request";
import compAdd from "./comAdd";
import compEdit from "./comEdit";
import { validatePhone } from "@/utils/validate";
export default {
  name: "PartyGroupGdReport",
  components: {
    compAdd,
    compEdit
  },
  data() {
    return {
      // appx信息
      appTable: {
        appId: "",
        appName: "",
        appSecurity: "",
        appType: "",
        code: ""
      },
      appArry: [],
      loading: false,
      modelAddFlag: false,
      modelEditFlag: false,
      options: [
        {
          value: "0",
          label: "否"
        },
        {
          value: "1",
          label: "是"
        }
      ],
      reportOptions: [
        {
          value: 0,
          label: "否"
        },
        {
          value: 1,
          label: "是"
        }
      ],
      countyOptions: this.$store.state.components.areaOptions,
      form: {
        coalNumber: "",
        groupName: "",
        registeredAddress: "",
        registeredCapital: "",
        uniformSocialCreditTime: "",
        businessScope: "",
        establishmentDate: "",
        registerDate: "",
        countrySubdivisionCode: "",
        legalPersonName: "",
        legalPersonTelephoneNumber: "",
        contactName: "",
        contactMobileTelephoneNumber: "",
        ipcnum: "",
        psnrnum: "",
        branch: "",
        report: ""
      },
      rules: {
        registeredAddress: [
          { required: true, message: "请输入注册地址", trigger: "blur" }
        ],
        registeredCapital: [
          { required: true, message: "请输入注册资金", trigger: "blur" }
        ],
        uniformSocialCreditTime: [
          {
            type: "string",
            required: true,
            message: "请选择日期",
            trigger: "change"
          }
        ],
        businessScope: [
          { required: true, message: "请输入经营范围", trigger: "blur" }
        ],
        establishmentDate: [
          {
            type: "string",
            required: true,
            message: "请选择日期",
            trigger: "change"
          }
        ],
        registerDate: [
          {
            type: "string",
            required: true,
            message: "请选择日期",
            trigger: "change"
          }
        ],
        countrySubdivisionCode: [
          { required: true, message: "请选择所属辖区", trigger: "change" }
        ],
        legalPersonName: [
          { required: true, message: "请输入法人姓名", trigger: "change" }
        ],
        legalPersonTelephoneNumber: [
          {
            required: true,
            validator(rule, value, callback) {
              validatePhone(value)
                ? callback()
                : callback(new Error("请输入正确的手机号"));
            },
            trigger: "blur"
          }
        ],
        contactName: [
          { required: true, message: "请输入联系人名称", trigger: "blur" }
        ],
        contactPhone: [
          { required: true, message: "请输入联系人电话", trigger: "blur" }
        ],
        contactMobileTelephoneNumber: [
          {
            required: true,
            validator(rule, value, callback) {
              validatePhone(value)
                ? callback()
                : callback(new Error("请输入正确的手机号"));
            },
            trigger: "blur"
          }
        ],
        ipcnum: [
          {
            required: true,
            message: "请输入电信业务经营许可证编号",
            trigger: "blur"
          }
        ],
        psnrnum: [
          { required: true, message: "请输入三级等保备案编号", trigger: "blur" }
        ],
        businessType: [
          {
            required: true,
            message:
              "请输入干线普货运输、城市配送、农村配送、集装箱运输、港口物流、其他等六类",
            trigger: "blur"
          }
        ],
        cargoType: [
          {
            required: true,
            message:
              "请输入电子产品、商品汽车、冷藏货物、大宗货物、快速消费品、农产品、其他",
            trigger: "blur"
          }
        ],
        managementArea: [
          { required: true, message: "请输入经营区域", trigger: "blur" }
        ],
        brancheCount: [
          { required: true, message: "请输入分公司个数", trigger: "blur" }
        ],
        reportCount: [
          { required: true, message: "请输入运管机构报备个数", trigger: "blur" }
        ],
        actualCarrierCount: [
          { required: true, message: "请输入实际承运人个数", trigger: "blur" }
        ],
        vehicleCount: [
          { required: true, message: "请输入实际车辆个数", trigger: "blur" }
        ],
        driverCount: [
          { required: true, message: "请输入实际承运人个数", trigger: "blur" }
        ]
      }
    };
  },
  created() {
    this.getInfo();
    // this.Seladdress();
    this.getAppInfo();
    this.findApplist();
  },
  methods: {
    getInfo() {
      return request({
        url: `/ntocc-basic-api/partyGroup/one`,
        method: "get"
      }).then(response => {
        if (response.data) {
          this.form = response.data;
        }
      });
    },
    // 获取app信息
    findApplist() {
      return new Promise(resolve => {
        request({
          url: "/ntocc-basic-api/guangdongAppInfo",
          method: "get",
          params: this.appTable.code
        }).then(response => {
          this.appArry = response.data.records;
          resolve();
        });
      });
    },
    // 增加组件的父方法
    fatherAdd() {
      this.modelAddFlag = false;
      this.findApplist();
    },
    // 编辑组件的父方法
    fatherEdit() {
      this.modelEditFlag = false;
      this.findApplist();
    },
    // 公共取消
    fatherCancel(modelFlag) {
      switch (modelFlag) {
        case "add":
          this.modelAddFlag = false;
          break;
        case "edit":
          this.modelEditFlag = false;
          break;
        case "detail":
          this.modelDetailFlag = false;
          break;
        default:
      }
    },
    // 添加方法
    funcAdd() {
      this.modelAddFlag = true;
    },
    // 修改方法
    funcEdit(code) {
      this.$refs.editRef.getInfo(code);
      this.modelEditFlag = true;
    },
    // 删除方法/
    funcDelete(row) {
      this.$confirm("确认删除吗？")
        .then(_ => {
          request({
            url: `/ntocc-basic-api/guangdongAppInfo`,
            method: "delete",
            params: { codes: row }
          }).then(response => {
            this.$message({ message: response.msg, type: "success" });
            this.findApplist();
          });
        })
        .catch(_ => {});
    },
    getAppInfo() {
      return request({
        url: `/ntocc-basic-api/guangdongAppInfo`,
        method: "get"
      }).then(response => {
        if (response.data) {
          this.appTable = response.data.records[0];
        }
      });
    },
    getLabels(node) {
      if (node instanceof Array) {
        node = node[0];
      }
      if (node) {
        return node.value;
      }
    },
    handleChange() {
      let countrySubdivisionCode = this.getLabels(
        this.$refs["countrySubdivisionCode"].getCheckedNodes()
      );
      this.form.countrySubdivisionCode = countrySubdivisionCode;
      // if (this.form.branch=='1'){
      // }
    },
    isBranchFun(value) {
      // if (value == '1'){
      // }
    },

    isFloor(e) {
      e.target.value = e.target.value.match(/^\d*(\.?\d{0,1})/g)[0] || null;
    },
    formatterSendFundStatus({ cellValue }) {
      switch (cellValue) {
        case 1:
          return "安卓";
        case 2:
          return "IOS";
        default:
          break;
      }
    },
    // 提交
    funcSubmitJs() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const data = this.form;
          const rLoading = this.openLoading();
          if (data.code) {
            request({
              url: "/ntocc-basic-api/partyGroup",
              method: "put",
              params: data
            }).then(response => {
              this.getInfo();
              rLoading.close();
              this.$message({ message: response.msg, type: "success" });
            });
          } else {
            request({
              url: "/ntocc-basic-api/partyGroup",
              method: "post",
              params: data
            }).then(response => {
              this.getInfo();
              rLoading.close();
              this.$message({ message: response.msg, type: "success" });
            });
          }
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.titleh1 {
  line-height: 50px;
  border-bottom: 1px solid #e2e2e2;
  margin-bottom: 15px;
}
::v-deep .el-textarea__inner {
  min-height: 151px !important;
  height: 151px !important;
}
.vxe-table .vxe-body--column:not(.col--ellipsis),
.vxe-table .vxe-footer--column:not(.col--ellipsis),
.vxe-table .vxe-header--column:not(.col--ellipsis) {
  padding: 6px 0;
}
.vxe-toolbar {
  padding: 0 0 10px 0;
}
</style>
